import { Outlet } from "react-router-dom";
import { Sidebar } from "@/components/Sidebar";

/**
 * AppLayout — Internal app screens with sidebar.
 *
 * Structure (design-system.md §4.1):
 *   Screen (horizontal flexbox, 100vw x 100vh)
 *   ├── Sidebar (243px fixed)
 *   └── Main Content (flex-1, overflow-y-auto)
 *       └── <Outlet /> — React Router nested route content
 */
export function AppLayout() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        height: "100vh",
        backgroundColor: "var(--bg-page)",
        overflow: "hidden",
      }}
    >
      <Sidebar />

      <main
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "32px",
          display: "flex",
          flexDirection: "column",
          gap: "24px",
          minWidth: 0, // Prevent flex blowout
        }}
      >
        <Outlet />
      </main>
    </div>
  );
}
